import React from 'react'
import { withStyles, ListItem, Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { criteriaLabels } from '../constants/criteria.variants'
import Button from 'components/Button';
import Tr from 'translations/Translations';

const style = theme => ({
	root: {

	},
	grid: {
		'&>*': {
			'&:not(:first-child)': {
				marginLeft: theme.spacing(1)
			}
		}
	},
	nameItem: {
		width: 200,
		flexShrink: 0,
	},
	typeItem: {
		width: 100,
		flexShrink: 0,
	},
	descriptionItem: {
		flexGrow: 1,
	},
	text: {
		...theme.typography.cutLines(1),
	}
})

function ListElement({
	classes,
	name,
	type,
	description,
	onClick
}) {
	const text = (t) => (<Typography className={classes.text} variant='body1'>{t}</Typography>)

	return (
		<ListItem>
			<Grid
				container
				className={classes.grid}
				wrap='nowrap'
				alignItems='center'
			>
				<Grid item className={classes.nameItem}>
					{text(name)}
				</Grid>
				<Grid item className={classes.typeItem}>
					{text(criteriaLabels[type])}
				</Grid>
				<Grid item className={classes.descriptionItem}>
					{text(description)}
				</Grid>
				<Grid item>
					<Button variant='text' onClick={onClick}>
						{Tr('select')}
					</Button>
				</Grid>
			</Grid>
		</ListItem>
	)
}

ListElement.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(ListElement);